import React, { MouseEventHandler } from 'react';

const ScrollButton: React.FunctionComponent<{onClick: MouseEventHandler}> = ({onClick}) => (
    <a href="#" onClick={onClick} className="scroller">
        <i className="icon"></i>
    </a>
)

export default ScrollButton